var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcMddColorfulDark = function SvgIcMddColorfulDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#4A3C30"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.477 23.476c.694 0 1.354-.354 1.646-.983A9.465 9.465 0 0 0 27 18.5a9.5 9.5 0 0 0-19 0c0 1.426.314 2.779.877 3.993.292.63.952.983 1.646.983h13.954ZM17.557 28h-.115.116Z",
    fill: "#F1927D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m20.266 14.458.002-.004a.383.383 0 1 0-.704-.3l-2.968 5.083a1.15 1.15 0 0 0-.144.245v.001a1.148 1.148 0 1 0 2.19.626l1.624-5.651Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.084 9.5c.347 0 .628.281.628.628v1.31a.628.628 0 0 1-1.256 0v-1.31c0-.347.28-.628.628-.628ZM24.956 13.472a.628.628 0 0 1 0 .889l-1.036 1.035a.628.628 0 1 1-.889-.888l1.036-1.036a.628.628 0 0 1 .889 0ZM12.768 14.508a.628.628 0 0 0 0-.889l-1.035-1.035a.628.628 0 0 0-.889.888l1.036 1.036a.628.628 0 0 0 .888 0Z",
    fill: "#fff",
    fillOpacity: 0.4
  })));
};
export default SvgIcMddColorfulDark;